<template>
  <TransitionGroup v-show="alerts.length" class="AlertGroup" tag="div" name="alerts">
    <AlertBox v-for="alert in alerts" :key="alert.id" v-bind="alert" @dismiss="dismiss" />
  </TransitionGroup>
</template>

<script setup>
import { useAlerts } from '@/composables/alerts';
import AlertBox from '@/components/AlertBox.vue';

const { alerts, dismiss } = useAlerts();
</script>

<style lang="postcss">
.AlertGroup {
  @apply fixed;
  top: 0;
  left: 0;
  right: 0;

  z-index: 99999;
}

.Alert + .Alert {
  margin-top: 1rem;
}

@screen lg {
  .AlertGroup {
    top: 2rem;
    bottom: unset;
    left: 2rem;
    right: unset;
  }
}

.alerts-enter-active,
.alerts-leave-active {
  transition-property: transform;
  transition-timing-function: ease-in-out;
  transition-duration: 300ms;
}

.alerts-enter,
.alerts-leave-to {
  transform: translate3d(200%, 0, 0);
}
</style>
